export const LANG = {
  ru: {
    nav: ['О себе', 'Музыка', 'Услуги', 'Пресс-кит', 'Галерея', 'Бронирование'],
    hero: {
      sub: 'ВОКАЛИСТКА · DJ · АВТОР ПЕСЕН',
      cta: 'Забронировать выступление',
      cta2: 'Слушать музыку',
    },
    marquee:
      'JULIA MILOWS — VOCALIST — DJ — SONGWRITER — МОСКВА — POP — R\'N\'B — DEEP HOUSE — EDM — ',
    about: {
      tag: '01 / БИОГРАФИЯ',
      title: 'История',
      accent: 'Голоса',
      p1: 'Голос, который невозможно забыть. Julia Milows — вокалистка, DJ и автор песен, чей путь от первых нот в два года до главных сцен страны стал одной из самых ярких историй нового поколения российской музыки.',
      p2: 'Первое место в вокальном шоу «Ярче звезд» (ТНТ, 2023) и кресло жюри «Ну-ка, все вместе!» (Россия-1) — закономерный итог лет упорной работы. Хедлайнер «Таврида-Арт», автор 15+ треков, звучащих на всех стриминговых платформах.',
      p3: 'Сегодня Julia Milows — это не просто артист, а бренд, объединяющий музыку, стиль и энергию. Выступает на русском и английском языках. От камерных вечеров до стадионных шоу — везде, где она появляется, начинается музыка.',
    },
    music: {
      tag: '02 / ДИСКОГРАФИЯ',
      title: 'Послушайте',
      accent: 'Музыку',
      spot: 'Spotify',
      apple: 'Apple Music',
      desc: 'Авторские треки и коллаборации с лучшими продюсерами',
    },
    services: {
      tag: '03 / УСЛУГИ',
      title: 'Чем могу',
      accent: 'Помочь',
      items: [
        {
          i: '01',
          t: 'Живое выступление',
          d: 'Вокал и DJ-сет на свадьбах, корпоративах, фестивалях и частных мероприятиях',
          p: 'от ₽70 000',
        },
        {
          i: '02',
          t: 'Сессионный вокал',
          d: 'Профессиональная запись из студии — lead, бэк-вокал, гармонии. 24bit/48kHz',
          p: 'от $100',
        },
        {
          i: '03',
          t: 'Написание песен',
          d: 'Topline, мелодии, тексты на русском и английском языках',
          p: 'от $300',
        },
        {
          i: '04',
          t: 'DJ-сет',
          d: 'Музыкальное сопровождение любого формата — от лаунжа до клуба',
          p: 'по запросу',
        },
        {
          i: '05',
          t: 'Вокальный продюсинг',
          d: 'Полный цикл создания трека: от идеи до релиза. Помощь с аранжировкой, записью, сведением и дистрибуцией',
          p: 'по запросу',
        },
        {
          i: '06',
          t: 'Марафон «Сильный голос»',
          d: '4-недельный авторский курс для тех, кто хочет раскрыть свой вокал — от новичков до практикующих',
          p: 'по запросу',
        },
      ],
    },
    epk: {
      tag: '04 / ПРЕСС-КИТ',
      title: 'Для',
      accent: 'Организаторов',
      sub: 'Информация для организаторов мероприятий и СМИ',
      bio: 'Julia Milows (Юлия Милованова) — одна из самых ярких вокалисток и DJ-артистов нового поколения. Победительница вокального шоу «Ярче звезд» (ТНТ, 2023), член жюри «Ну-ка, все вместе!» (Россия-1). Работает на стыке Pop, R\'n\'B, Deep House и EDM — от камерных клубных сетов до стадионных шоу. В дискографии — 25+ авторских треков и коллаборации с DNDM, DJ Nejtrino, Alex Alta, Tim Dian. Выступает на русском и английском языках. 2 млн слушателей на Яндекс.Музыке. География: Москва.',
      rider:
        'PA от 2 кВт · Мониторная линия · Shure/Sennheiser · Pioneer CDJ/DDJ · Гримёрная',
      ach: [
        '1-е место — вокальное шоу «Ярче звезд», ТНТ (2023)',
        'Член жюри федерального шоу «Ну-ка, все вместе!», Россия-1',
        '2 млн слушателей на Яндекс.Музыке',
        'Ротация на Новом Радио, обложка плейлиста ВК Музыки',
        'Трек «Dreamers» в трендах TikTok — Ханна поделилась в сторис',
        'Хедлайнер «Таврида-Арт», серия вечеринок Russian Code',
        '25+ релизов: DNDM, DJ Nejtrino, Alex Alta, Niki Four, Tim Dian',
        'Вокальный продюсер и коуч, автор марафона «Сильный голос»',
      ],
      dl: 'Скачать пресс-кит',
      bioLabel: 'Биография',
      achLabel: 'Достижения',
      riderLabel: 'Технический райдер',
    },
    gallery: {
      tag: '05 / ГАЛЕРЕЯ',
      title: 'Визуальное',
      accent: 'Портфолио',
      scroll: '← Прокрутите →',
    },
    booking: {
      tag: '06 / БРОНИРОВАНИЕ',
      title: 'Давайте',
      accent: 'Создадим',
      sub: 'Заполните форму — отвечу в течение 24 часов',
      f: {
        name: 'Имя',
        email: 'Email',
        phone: 'Телефон',
        city: 'Город',
        type: 'Тип мероприятия',
        date: 'Дата',
        msg: 'Подробности',
        send: 'Отправить заявку',
        ok: '✓ Заявка отправлена!',
      },
      types: [
        'Свадьба',
        'Корпоратив',
        'Частная вечеринка',
        'Фестиваль',
        'Клуб',
        'Запись',
        'Другое',
      ],
      geo: 'Москва',
      geoLabel: 'География',
      socialsLabel: 'Соц. сети',
    },
    footer: 'Все права защищены',
  },

  en: {
    nav: ['About', 'Music', 'Services', 'Press Kit', 'Gallery', 'Booking'],
    hero: {
      sub: 'VOCALIST · DJ · SONGWRITER',
      cta: 'Book a Performance',
      cta2: 'Listen to Music',
    },
    marquee:
      'JULIA MILOWS — VOCALIST — DJ — SONGWRITER — MOSCOW — POP — R\'N\'B — DEEP HOUSE — EDM — ',
    about: {
      tag: '01 / BIOGRAPHY',
      title: 'The',
      accent: 'Story',
      p1: "A voice you don't forget. Julia Milows is a vocalist, DJ and songwriter whose journey — from first notes at age two to the country's biggest stages — has become one of the most compelling stories in a new generation of Russian music.",
      p2: "First place in the vocal show 'Yarche Zvyozd' (TNT, 2023) and a jury seat on 'Nu-ka, Vse Vmeste!' (Russia-1) — the natural result of years of relentless dedication. Headliner at Tavrida-Art, author of 15+ tracks streaming across every major platform.",
      p3: "Today Julia Milows is more than an artist — it's a brand that unites music, style and energy. Performs in Russian and English. From intimate evenings to stadium-scale shows — wherever she appears, the music begins.",
    },
    music: {
      tag: '02 / DISCOGRAPHY',
      title: 'Listen to',
      accent: 'the Music',
      spot: 'Spotify',
      apple: 'Apple Music',
      desc: 'Original tracks and collaborations with top producers',
    },
    services: {
      tag: '03 / SERVICES',
      title: 'How I Can',
      accent: 'Help',
      items: [
        {
          i: '01',
          t: 'Live Performance',
          d: 'Vocals and DJ set at weddings, corporate events, festivals and private parties',
          p: 'from ₽70,000',
        },
        {
          i: '02',
          t: 'Session Vocals',
          d: 'Professional studio recording — lead vocals, backing, harmonies. 24bit/48kHz',
          p: 'from $100',
        },
        {
          i: '03',
          t: 'Songwriting',
          d: 'Topline, melodies, lyrics in Russian and English',
          p: 'from $300',
        },
        {
          i: '04',
          t: 'DJ Set',
          d: 'Musical accompaniment from lounge to club format',
          p: 'on request',
        },
        {
          i: '05',
          t: 'Vocal Production',
          d: 'Full track creation cycle: from idea to release. Arrangement, recording, mixing & distribution',
          p: 'on request',
        },
        {
          i: '06',
          t: "'Strong Voice' Marathon",
          d: '4-week signature course to unlock your vocal potential — from beginners to practicing singers',
          p: 'on request',
        },
      ],
    },
    epk: {
      tag: '04 / PRESS KIT',
      title: 'For',
      accent: 'Organizers',
      sub: 'For event organizers and media',
      bio: "Julia Milows (Yulia Milovanova) — one of the brightest vocalists and DJ artists of the new generation. Winner of the vocal show 'Yarche Zvyozd' (TNT, 2023), jury member of 'Nu-ka, Vse Vmeste!' (Russia-1). Working at the intersection of Pop, R'n'B, Deep House and EDM — from intimate club sets to stadium-scale shows. Discography includes 25+ original tracks and collaborations with DNDM, DJ Nejtrino, Alex Alta, Tim Dian. Performs in Russian and English. 2M listeners on Yandex.Music. Based in Moscow.",
      rider:
        'PA from 2kW · Monitor line · Shure/Sennheiser · Pioneer CDJ/DDJ · Green room',
      ach: [
        "1st Place — vocal show 'Yarche Zvyozd', TNT (2023)",
        "Jury member — federal show 'Nu-ka, Vse Vmeste!', Russia-1",
        "2M listeners on Yandex.Music",
        "Radio rotation on Novoye Radio, VK Music playlist cover",
        "'Dreamers' trending on TikTok — shared by Khanna in stories",
        "Headliner at Tavrida-Art, Russian Code party series",
        "25+ releases: DNDM, DJ Nejtrino, Alex Alta, Niki Four, Tim Dian",
        "Vocal producer & coach, author of 'Strong Voice' marathon",
      ],
      dl: 'Download Press Kit',
      bioLabel: 'Biography',
      achLabel: 'Achievements',
      riderLabel: 'Technical Rider',
    },
    gallery: {
      tag: '05 / GALLERY',
      title: 'Visual',
      accent: 'Portfolio',
      scroll: '← Scroll →',
    },
    booking: {
      tag: '06 / BOOKING',
      title: "Let's",
      accent: 'Create',
      sub: "Fill out the form — I'll respond within 24 hours",
      f: {
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        city: 'City',
        type: 'Event Type',
        date: 'Date',
        msg: 'Details',
        send: 'Submit Request',
        ok: '✓ Request submitted!',
      },
      types: [
        'Wedding',
        'Corporate',
        'Private Party',
        'Festival',
        'Club',
        'Recording',
        'Other',
      ],
      geo: 'Moscow',
      geoLabel: 'Location',
      socialsLabel: 'Socials',
    },
    footer: 'All rights reserved',
  },

  ar: {
    nav: ['نبذة', 'الموسيقى', 'الخدمات', 'ملف صحفي', 'المعرض', 'الحجز'],
    hero: {
      sub: 'مغنية · دي جي · مؤلفة أغاني',
      cta: 'احجز عرضاً',
      cta2: 'استمع للموسيقى',
    },
    marquee:
      'JULIA MILOWS — مغنية — دي جي — مؤلفة — موسكو — بوب — آر أند بي — ديب هاوس — ',
    about: {
      tag: '01 / السيرة الذاتية',
      title: 'القصة',
      accent: 'وراء الصوت',
      p1: 'صوت لا يُنسى. Julia Milows — مغنية ودي جي ومؤلفة أغاني، رحلتها من النوتات الأولى في عمر السنتين إلى أكبر المسارح أصبحت واحدة من أبرز قصص الجيل الجديد في الموسيقى الروسية.',
      p2: 'المركز الأول في مسابقة «ألمع من النجوم» (TNT، 2023) ومقعد في لجنة تحكيم «هيا جميعاً!» (روسيا-1) — نتيجة طبيعية لسنوات من التفاني. نجمة مهرجان «تافريدا-آرت»، مؤلفة +15 أغنية على جميع المنصات.',
      p3: 'اليوم Julia Milows ليست مجرد فنانة — بل علامة تجمع بين الموسيقى والأناقة والطاقة. تؤدي بالروسية والإنجليزية. من الأمسيات الحميمة إلى العروض الكبرى — حيثما ظهرت، تبدأ الموسيقى.',
    },
    music: {
      tag: '02 / الألبومات',
      title: 'استمع إلى',
      accent: 'الموسيقى',
      spot: 'سبوتيفاي',
      apple: 'آبل ميوزك',
      desc: 'أغانٍ أصلية وتعاون مع أفضل المنتجين',
    },
    services: {
      tag: '03 / الخدمات',
      title: 'كيف يمكنني',
      accent: 'المساعدة',
      items: [
        { i: '01', t: 'عرض حي', d: 'غناء ودي جي في حفلات الزفاف والفعاليات والمهرجانات', p: 'من ₽70,000' },
        { i: '02', t: 'تسجيل صوتي', d: 'تسجيل احترافي — صوت رئيسي وخلفي. 24bit/48kHz', p: 'من $100' },
        { i: '03', t: 'كتابة أغاني', d: 'ألحان وكلمات بالروسية والإنجليزية', p: 'من $300' },
        { i: '04', t: 'دي جي سِت', d: 'مرافقة موسيقية من اللاونج إلى الكلوب', p: 'عند الطلب' },
      ],
    },
    epk: {
      tag: '04 / ملف صحفي',
      title: 'للمنظمين',
      accent: 'والإعلام',
      sub: 'معلومات لمنظمي الفعاليات ووسائل الإعلام',
      bio: 'Julia Milows (يوليا ميلوفانوفا) — واحدة من ألمع المغنيات وفنانات الدي جي في الجيل الجديد. فائزة بمسابقة «ألمع من النجوم» (TNT، 2023)، عضو لجنة تحكيم «هيا جميعاً!» (روسيا-1). تعمل عند تقاطع البوب والآر أند بي والديب هاوس والإي دي إم. +25 أغنية أصلية وتعاون مع DNDM وDJ Nejtrino وAlex Alta. تؤدي بالروسية والإنجليزية. 2 مليون مستمع على Yandex.Music. موسكو.',
      rider: 'نظام صوت 2 كيلوواط · خط مونيتور · Shure/Sennheiser · Pioneer CDJ/DDJ · غرفة خاصة',
      ach: ['المركز الأول — مسابقة «ألمع من النجوم»، TNT (2023)', 'عضو لجنة تحكيم «هيا جميعاً!»، روسيا-1', '2 مليون مستمع على Yandex.Music', 'بث إذاعي على Novoye Radio، غلاف قائمة VK Music', '«Dreamers» في تريندات TikTok', 'نجمة مهرجان «تافريدا-آرت»، سلسلة حفلات Russian Code', '+25 إصدار: DNDM، DJ Nejtrino، Alex Alta، Tim Dian', 'منتجة صوتية ومدربة، مؤلفة ماراثون «الصوت القوي»'],
      dl: 'تحميل الملف الصحفي',
      bioLabel: 'السيرة',
      achLabel: 'الإنجازات',
      riderLabel: 'المتطلبات التقنية',
    },
    gallery: {
      tag: '05 / المعرض',
      title: 'بورتفوليو',
      accent: 'بصري',
      scroll: '← مرر →',
    },
    booking: {
      tag: '06 / الحجز',
      title: 'لنبدع',
      accent: 'معاً',
      sub: 'املأ النموذج — سأرد خلال 24 ساعة',
      f: { name: 'الاسم', email: 'البريد', phone: 'الهاتف', city: 'المدينة', type: 'نوع الفعالية', date: 'التاريخ', msg: 'التفاصيل', send: 'إرسال الطلب', ok: '✓ تم إرسال الطلب!' },
      types: ['زفاف', 'شركات', 'حفلة خاصة', 'مهرجان', 'نادي', 'تسجيل', 'أخرى'],
      geo: 'موسكو',
      geoLabel: 'الموقع',
      socialsLabel: 'التواصل',
    },
    footer: 'جميع الحقوق محفوظة',
  },
};

export const SECTION_IDS = ['about', 'music', 'services', 'epk', 'gallery', 'booking'];
